import React from 'react'
import '../../components/tableComponents/tables.css'
import './index.css'
import TableRow from './Tablerow'
import NewTableRow from './NewTableRow'

export default function GroupTable({ data, setData }) {
	const pexEntries = [
		'read',
		'read_owner',
		'read_artist',
		'read_artwork',
		'read_owner_names',
		'read_artist_names',
		'write',
		'write_own',
		'admin',
	]

	const deleteGroup = (groupId) => {
		setData((state) => state.filter((e) => e.id !== groupId))
	}

	const setDataElement = (index, dataElement) => {
		const dataObject = [...data]
		dataObject[index] = dataElement
		setData(dataObject)
	}

	return (
		<table className='permissionsTable'>
			<colgroup>
				<col className='colgroup firstColgroup' span='1'></col>
				<col className='colgroup' span='1'></col>
				<col className='colgroup' span='6'></col>
				<col className='colgroup' span='2'></col>
				<col className='colgroup' span='4'></col>
				<col className='colgroup' span='1'></col>
			</colgroup>
			<thead>
				<tr className='noBorderRow'>
					<th colSpan={1} className='mainTableHeading'>
						ID
					</th>
					<th colSpan={1} className='mainTableHeading'>
						Nutzergruppen
					</th>
					<th colSpan={6} className='mainTableHeading'>
						Lesen
					</th>
					<th colSpan={2} className='mainTableHeading'>
						Bearbeiten
					</th>
					<th colSpan={1} className='mainTableHeading'>
						Admin Panel
					</th>
				</tr>
				<tr className='headRow'>
					<th className='tableSubHeading spacerHeading'></th>
					<th className='tableSubHeading spacerHeading'></th>
					<th className='tableSubHeading'>Alles</th>
					<th className='tableSubHeading'>Besitzer-Masken</th>
					<th className='tableSubHeading'>Künstler-Masken</th>
					<th className='tableSubHeading'>Werke-Masken</th>
					<th className='tableSubHeading'>Besitzer-Namen</th>
					<th className='tableSubHeading'>Künstler-Namen</th>
					<th className='tableSubHeading'>Alles</th>
					<th className='tableSubHeading'>eigene Einträge</th>
					<th className='tableSubHeading'>Admin</th>
				</tr>
			</thead>
			<tbody>
				{data &&
					data.map(
						(dataElement, index) =>
							!!dataElement.id && (
								<TableRow
									key={index}
									dataElement={dataElement}
									index={index}
									setDataElement={(e) => setDataElement(index, e)}
									deleteElement={() => {
										deleteGroup(dataElement.id)
									}}
									pexEntries={pexEntries}
								/>
							)
					)}
				{data &&
					data.map(
						(dataElement, index) =>
							!dataElement.id && (
								<NewTableRow
									key={index}
									dataElement={dataElement}
									setDataElement={(e) => setDataElement(index, e)}
									pexEntries={pexEntries}
								/>
							)
					)}
			</tbody>
		</table>
	)
}
